module.exports = __webpack_public_path__ + "static/media/outlets.049f875f.svg";